/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckSelected/view.blocks to change it.
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CheckSelected({
  children,
  viewPath = "/DesignSystem/Svgs/CheckSelected",
  marginLeft = 0,
  opacity = 1,
  width = 18,
  height = 18,
  stroke = "rgba(0, 188, 112, 0.83)"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CheckSelected.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-7WBdA': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--o-2-7WBdA': opacity}}
 className={`views-block ${styles.Vertical}`}
>
<Check
  viewPath={`${viewPath}/Check`}
 width={width}
 height={height}
 stroke={stroke}
/>
</div>
{children}
</React.Fragment>)
}